/* YUUMA help pages: client-side form checks (mirrors the design's checkForm),
   copy-to-clipboard, print, password reveal, and gift card QR code. No dependencies. */
(function () {
  'use strict';
  if (window.__yuumaHelp) return;
  window.__yuumaHelp = true;

  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function labelFor(el) {
    if (el.getAttribute('data-label')) return el.getAttribute('data-label');
    if (el.getAttribute('aria-label')) return el.getAttribute('aria-label');
    var wrap = el.closest('label');
    var span = wrap && wrap.querySelector('span');
    return ((span && span.textContent) || el.placeholder || 'This field').replace(/\s*\*$/, '').trim();
  }

  function checkForm(form) {
    var bad = null;
    [].forEach.call(form.elements, function (el) {
      if (!el.willValidate || el.type === 'submit' || el.type === 'hidden') return;
      var v = (el.value || '').trim();
      var msg = null;
      if (el.type === 'checkbox') {
        if (el.required && !el.checked) msg = el.getAttribute('data-msg') || 'Please agree to continue.';
      } else if (el.required && !v) msg = labelFor(el) + ' is required.';
      else if (el.type === 'email' && v && !EMAIL.test(v)) msg = 'Enter an email like name@example.com.';
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      var bar = el.closest('[data-help-bar]');
      if (bar) bar.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (msg && !bad) bad = { el: el, msg: msg };
    });
    if (bad) bad.el.focus();
    return bad ? bad.msg : null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-help-validate')) return;
    var err = checkForm(form);
    var box = form.querySelector('[data-help-error]');
    if (err) {
      e.preventDefault();
      if (box) { box.textContent = err; box.hidden = false; }
    } else if (box) {
      box.hidden = true;
    }
  }, true);

  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-help-copy]');
    if (copy) {
      var text = copy.getAttribute('data-help-copy');
      var done = function () {
        var label = copy.getAttribute('data-label-done') || 'Copied';
        var orig = copy.getAttribute('data-label') || copy.textContent;
        copy.setAttribute('data-label', orig);
        copy.textContent = label;
        clearTimeout(copy._t);
        copy._t = setTimeout(function () { copy.textContent = orig; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, done);
      else done();
      return;
    }
    if (e.target.closest('[data-help-print]')) { window.print(); return; }
    var reveal = e.target.closest('[data-pw-reveal]');
    if (reveal) {
      var target = document.getElementById(reveal.getAttribute('aria-controls'));
      if (target) {
        target.hidden = false;
        reveal.hidden = true;
        reveal.setAttribute('aria-expanded', 'true');
        var input = target.querySelector('input[type="password"]');
        if (input) input.focus();
      }
    }
  });

  /* Gift card QR code (Shopify's vendor/qrcode.js exposes window.QRCode) */
  function initQr() {
    [].forEach.call(document.querySelectorAll('[data-qr-identifier]'), function (el) {
      if (el._qr || !window.QRCode) return;
      el._qr = true;
      /* eslint-disable-next-line no-new */
      new window.QRCode(el, { text: el.getAttribute('data-qr-identifier'), width: 120, height: 120, correctLevel: window.QRCode.CorrectLevel ? window.QRCode.CorrectLevel.M : 0 });
    });
  }

  /* Password page background video: never autoplay for reduced motion */
  function initMotion() {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    [].forEach.call(document.querySelectorAll('video[data-help-autoplay]'), function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (err) { /* noop */ }
    });
  }

  function initForms() { [].forEach.call(document.querySelectorAll('form.js-help-validate'), function (f) { f.noValidate = true; }); }

  function init() { initForms(); initQr(); initMotion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', initQr);
})();
